<div (click)="clickNewButton()" [ngClass]="showScrollButton ? 'top-button' : 'bottom-button'"
     [style.visibility]="showNewButton ? 'visible' : 'hidden'"
     class="floating-button add-button">
  <span class="material-symbols-outlined f-w-600 text-center">add</span>
</div>

<div (click)="scrollTop()" [style.visibility]="showScrollButton ? 'visible' : 'hidden'"
     [class.scroll-button--analysis-info]="isAnalysisInfoPage"
     [class.scroll-button--my-house]="isMyHouseInfoPage"
     [class.scroll-button--my-house-native-ios]="isMyHouseInfoPage && nativeIos"
     aria-label="페이지 맨 위로 이동" class="floating-button scroll-button bottom-button" role="button">
  <span class="material-symbols-outlined f-w-600 text-center">arrow_upward</span>
</div>

